module.exports = __webpack_public_path__ + "img/6.18c58587.png";